import React, { useReducer } from "react";
import styles from "./Step.module.css";
import StepsHeader from "../../../Components/StepsHeader/StepsHeader";
import address from "../../../assets/componentAssets/address.png";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Radio,
  RadioGroup,
} from "@mui/material";
import { reducer } from "../consumptionReducer";
import { formAddress } from "../InitialState/formAddress";
import CustomInput from "../../../Components/CustomInput/CustomInput";
import { formAddress1 } from "../../../Utility/utils";
function Address() {
  const [state, dispatch] = useReducer(reducer, formAddress);
  const handleChange = (event) => {
    const { name, value } = event.target;
    dispatch({
      type: "UPDATE_FIELD",
      payload: {
        name,
        value,
      },
    });
  };

  return (
    <div className={styles.con}>
      <StepsHeader
        image={address}
        heading={"Billing and Delivery Address"}
        secPara="Please provide proper information"
      />
      <div className={styles.fieldDetails}>
        <div className={styles.fieldCom}>
          <div className={styles.fields}>
            <p className={styles.fieldName}>
              What lies below the ground floor?
            </p>
            <FormControl>
              <RadioGroup>
                <div className={styles.Radio1}>
                  <FormControlLabel
                    value="Unheated basement"
                    control={<Radio />}
                    label="Unheated basement"
                  />
                  <FormControlLabel
                    value="Heated cellar"
                    control={<Radio />}
                    label="Heated cellar"
                  />
                  <FormControlLabel
                    value="No basement available/ floor slab"
                    control={<Radio />}
                    label="No basement available/ floor slab"
                  />
                </div>
              </RadioGroup>
            </FormControl>
          </div>
          <div className={styles.fieldCom}>
            {formAddress1.map((field) => (
              <div className={styles.fields}>
                <CustomInput
                  key={field.id}
                  label={field.title}
                  name={field.name}
                  value={state[field.name]}
                  onChange={handleChange}
                  options={field.options || []}
                  {...field}
                />
              </div>
            ))}
          </div>
          <div className={styles.hr} />
          {/* <div className={styles.fields}> */}
            <p className={styles.fieldName}>Add On Services</p>
            <FormGroup>
              <FormControlLabel
              sx={{padding:"20px 0px"}}
                control={<Checkbox />}
                label={
                  <div>
                    <p className={styles.mainText}>
                      High-quality postal dispatch of ID cards and invoices
                    </p>
                    <p className={styles.subText}>
                      We will send you the energy certificate and the invoice by
                      post as a DIN A4 letter. Shipping takes place within 24
                      hours. Order more than one printout.
                    </p>
                  </div>
                }
              />
              <FormControlLabel
                required
                control={<Checkbox />}
                label={
                  <div>
                    <p className={styles.mainText}>Express exhibition today</p>
                    <p className={styles.subText}>
                      If you are in a hurry, we offer you the option of express
                      processing. We guarantee that your ID will be checked
                      today. If the check is successful, you will receive your
                      energy certificate in digital form by e-mail today.
                      Tested, DIBt-registered and legally valid for 10
                      years. (For orders placed before 8 p.m.).
                    </p>
                  </div>
                }
              />
            </FormGroup>
          </div>
        {/* </div> */}
      </div>
    </div>
  );
}

export default Address;
